module.exports = __webpack_public_path__ + "static/media/explore2.4196bd15.jpg";